import { useInView } from "react-intersection-observer";
import React from "react";
import Footer from '../Sections/Footer'
import Project from '../Sections/templates/Project';
import Newviewer from "../Sections/Newviewer";

const ProjectOne= ({projectjson,handleIntersect}) => {

    const { ref} = useInView({
            threshold: 0.2,
            triggerOnce: false,
            onChange: (inView) => {
              if (inView){
                 handleIntersect("projects");
            }
            },
          });
    
    return (  <div ref={ref} className="ProjectOne">
        <Newviewer images={projectjson.gallery.items}/>
        <Project projectjson={projectjson}/>
        <Footer/>
        </div>);
};

export default ProjectOne;